import {Component, Vue, Watch} from 'vue-property-decorator'
import {gettHeaderByType, settHeaderByType} from '@/api/common'
import {
    getFinanceInvoiceList,
    delFinanceInvoiceById,
    financeInvoiceExportData,
    setFinanceInvoiceStatus,
    getFinanceInvoiceById,
    getCompanyList, updFinanceInvoiceById
} from '@/api/financial-center'
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from '@/utils'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class MakeInvoice extends Vue {
    // 删除
    delOrderId: number = null
    delOrderDialogShow = false
    // 撤回审批
    cancelApproveDialog = false
    cancelApproveId: number = undefined
    // data
    tableHeadPopoverShow = false
    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableHead: any[] = []
    tableData = []
    // tableRandom = Math.random()
    tableLoading = false
    page = 1
    limit = 20
    total = 0
    tableHeadFilter: any = {
        mainPart: '',  //开票主体
        mainPartName: '',  //主体名称
        title: '',  //开票抬头
        createdAt: '',  //提交时间
        invoiceAt: '',  //财务开票时间
        directorUserIdList: [], //负责人id
        status: '', //开票状态
        code: '', //开票编号
        price: '',//本次开票金额
        account: '', // 收款账户
    }
    filter_invoiceAt: Date[] = []
    filter_price = '' //本次开票金额
    filter_amount = '' //本次开票金额

    tableCheckedData = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    tableKey = Math.random()
    loading = false
    exportButtonDisabled = false
    exportHeaderDialogVisible = false
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []
    companyList = []  // 收款账户
    dcoVoidDialogShow = false
    voidId = ''
    // 作废弹框内的开票明细，每行含 voidPrice 作废金额
    voidDetailList: any[] = []

    menuBtn = menuBtn

    // computed
    get invoiceAt() {
        let str = ''
        if (!this.filter_invoiceAt || this.filter_invoiceAt.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_invoiceAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_invoiceAt[1]))
        }
        return str
    }

    get arrfilter_amount() {
        const filter_amount = this.filter_amount
        const filter_price = this.filter_price
        return {
            filter_amount, filter_price
        }
    }

    created() {
        this.gettHeaderByType()
        this.getCompanyList()
    }

    changeDirectorUsers(e) {
        this.tableHeadFilter.directorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changeReceiverUser(e) {
        this.receiverUser = e.id
    }

    // 列表
    async getTableData() {
        this.loading = true

        this.tableHeadFilter.price = this.filter_amount + this.filter_price
        this.tableHeadFilter.invoiceAt = this.invoiceAt //财务开票时间
        const obj = {...this.tableHeadFilter, page: this.page, limit: this.limit}
        for (const key in obj) {
            if (key === 'createdAt') {
                obj[key] = this.tableHeadFilter[key] && this.tableHeadFilter[key][0] && this.tableHeadFilter[key].length > 0 ? formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter[key][0])) + '/' + formatDate('yyyy-MM-dd', this.tableHeadFilter[key][1]) : ''
            } else {
                obj[key] = this.tableHeadFilter[key]
            }
            // if(!obj[key] || obj[key].length === 0) delete obj[key]
        }
        if (this.filter_amount && !this.filter_price) {
            delete obj.price
        }
        obj.page = this.page
        obj.limit = this.limit
        await getFinanceInvoiceList(delNullProperty(obj)).then((data: any) => {

            const {allNum, financeInvoiceList} = data
            this.total = allNum
            this.tableData = financeInvoiceList
            this.tableKey = Math.random()
            this.$nextTick(() => {
                if (this.$refs.multipleTable) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
        // this.isReadonly = false
    }

    // 表头
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(12)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            if (this.filter_amount && !this.filter_price) {
                this.$message.error('请输入价格');
                return
            }
            if (this.filter_price && !this.filter_amount) {
                this.$message.error('请选择运算符');
                return
            }
            this.page = page
            this.getTableData();
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.page = 1
        this.limit = limit
        this.getTableData();
    }

    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }

    // 操作删除
    hendleDelClick(id) {
        this.delOrderId = id
        this.delOrderDialogShow = true
    }

    // 确定删除
    async delOrderDialogConfirm() {
        await delFinanceInvoiceById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }

    // 撤回审批
    clickcancelApproveButton(row) {
        this.cancelApproveId = row.id
        this.cancelApproveDialog = true
    }


    async clickCancelApproveDialogConfirmButton() {
        await setFinanceInvoiceStatus({id: this.cancelApproveId, action: '1'})
        this.$message.success('撤销审批成功')
        this.cancelApproveDialog = false
        this.getTableData()
    }

    async setFinanceInvoiceStatus(row: any, action: string) {
        if (action === '0') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/makeInvoiceInfo?id=' + row.id + '&status=' + row.status + '&type=编辑' + '&isUpdatedData=1', '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
            return
        }
        await setFinanceInvoiceStatus({
            id: row.id,
            action
        })
        if (action == '1') {
            this.$message.success('成功撤回审批')
        }
        this.cancelApproveDialog = false
        this.getTableData()
    }

    // 点击编辑跳转
    clickEditButton(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/makeInvoiceInfo?id=' + row.id + '&status=' + row.status + '&type=编辑' + '&isUpdatedData=0', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    // 设置表头
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 12, headerIds: this.draggableList})
            // this.tableKey = Math.random()
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    // 多选更换负责人
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
    }

    // 新建开票
    openNewPartner() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/makeInvoiceAdd', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    // 点击表格进入详情
    handleScan(row: any) {
        if (!menuBtn(73))
            return
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/makeInvoiceInfo?id=' + row.id + '&status=' + row.status + '&isUpdatedData=0', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    // 导出
    async exportExcel(keys = '') {

        this.exportButtonDisabled = true
        const obj = {...this.tableHeadFilter, page: this.page, limit: this.limit, keys}
        for (const key in obj) {
            if (key === 'keys') continue
            if (obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
            if (key === 'createdAt') {
                obj[key] = this.tableHeadFilter[key] && this.tableHeadFilter[key][0] && this.tableHeadFilter[key].length > 0 ? formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter[key][0])) + '/' + formatDate('yyyy-MM-dd', this.tableHeadFilter[key][1]) : ''
            } else {
                obj[key] = this.tableHeadFilter[key]
            }
        }
        obj.keys = keys
        await financeInvoiceExportData(delNullProperty(obj))
            .then(()=>{
                this.$message.success('数据已转入后台导出, 请前往下载列表查看')
            })
            .finally(() => {
            this.exportButtonDisabled = false
        })

    }

    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList.filter(item => item.isShow == '1')
    }

    /*开票回款操作*/
    goToBackMoney(row) {
        let url = ''
        if (row.mainPart === '学生') {
            url = this.$route.matched[0].path + '/newBackMoneyStudent?makeInvoiceId=' + row.id
        }
        if (row.mainPart === '合作伙伴') {
            url = this.$route.matched[0].path + '/newBackMoneyMechanism?makeInvoiceId=' + row.id
        }
        const win = window.open(url, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    doVoid(row) {
        this.voidId = row.id
        this.voidDetailList = []
        getFinanceInvoiceById({id: row.id, isUpdatedData: '0'}).then((res: any) => {
            const arr = res.financeInvoice.financeInvoiceDetailList || []
            this.voidDetailList = arr.map(item => Object.assign({}, item, {
                thisTimePrice: item.price, //本次开票金额
                voidPrice: item.price || '' //作废金额默认等于本次开票金额
            }))
            this.dcoVoidDialogShow = true
        })
    }

    // 作废金额输入：只允许数字，最多两位小数
    handleVoidPriceInput(row, val) {
        row.voidPrice = (val || '').replace(/[^\d.]/g, '').replace(/^(\d*\.?\d{0,2}).*$/, '$1')
    }

    doVoidConfirm() {
        for (const item of this.voidDetailList) {
            const voidPrice = Number(item.voidPrice)
            if (item.voidPrice === '' || isNaN(voidPrice) || voidPrice < 0) {
                this.$message.error('请输入正确的作废金额')
                return
            }
            if (voidPrice > Number(item.financeOrderPrice)) {
                this.$message.error('作废金额不能大于订单金额')
                return
            }
        }
        const financeInvoiceDetailList = this.voidDetailList.map(item => ({
            financeOrderId: Number(item.financeOrderId),
            price: item.voidPrice
        }))
        updFinanceInvoiceById({
            id: Number(this.voidId),
            financeInvoiceDetailList: financeInvoiceDetailList
        }).then(() => {
            this.$message.success('作废成功')
            this.dcoVoidDialogShow = false
            this.getTableData()
        }).catch(() => {
            this.dcoVoidDialogShow = false
        })
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }

    @Watch('arrfilter_amount')
    handleAMount(nVal, oVal) {
        if ((nVal.filter_amount && nVal.filter_price) || (!nVal.filter_amount && !nVal.filter_price)) {
            this.pageChange(1)
        }
    }
}
